import { AppAction, AppLinkTargetCapability, Application } from '../../apis/eols-app-link/eols-app-link.constants';
import { isInstructor } from '../../utilities/common.utilities';
import { AssignmentTypeStrategy, CoursePlanClickSettings, CoursePlanTitleClickProps } from '../model';

// MCQ assignments are created and edited in the Medical Assessment app (CKSA), so create/edit only redirect, like EAQ.
// Assignment overview handlers are intentionally not defined here (MCQ performance page is SHER-11016).
export const mcqQuiz: AssignmentTypeStrategy = {
  // Instructors are redirected to the assignment in CKSA with ASSIGNMENT_EDIT, like the edit click.
  // TODO(SHER-10964): the student title click is an empty link for now; add the real behavior in follow-up work.
  coursePlanTitleClick: (props: CoursePlanTitleClickProps) => {
    const { defArgs, sharedAppLinkParams } = props;
    const { userRole, navigateToApp } = defArgs.props;
    if (isInstructor(userRole)) {
      navigateToApp({
        app: Application.EHE_MEDICAL_ASSESSMENT,
        action: AppAction.ASSIGNMENT_EDIT,
        body: { ...sharedAppLinkParams, targetCapability: AppLinkTargetCapability.ASSIGNMENT_BUILDER },
        includeLinkHash: true
      });
    }
    return Promise.resolve();
  },
  // TODO(SHER-10964): the MCQ assignment report click is an empty link for now, like the title; add the real behavior in follow-up work.
  coursePlanPerformanceReportClick: () => Promise.resolve(),
  coursePlanClickSettings: (props: CoursePlanClickSettings) => {
    const { assignment, defArgs, sharedAppLinkParams } = props;
    const { navigateToApp } = defArgs.props;
    const action = assignment ? AppAction.ASSIGNMENT_EDIT : AppAction.ASSIGNMENT_CREATE;
    navigateToApp({
      app: Application.EHE_MEDICAL_ASSESSMENT,
      action,
      body: { ...sharedAppLinkParams, targetCapability: AppLinkTargetCapability.ASSIGNMENT_BUILDER },
      includeLinkHash: true
    });
  }
};
